import type { MetaHealthError } from "@/types/meta";

/** What Meta suggests for each entity that cannot send freely, verbatim.
 *
 *  Meta's REASON is already in the health `detail` ("... Meta says: <reason>"), which is
 *  also the only text the /connections checklist renders -- so this lists the remedy and
 *  the code beside it rather than printing the reason a second time. */
export function MetaHealthErrorList({ errors }: { errors?: MetaHealthError[] | undefined }) {
  const remedies = (errors ?? []).filter((err) => err.solution);
  if (remedies.length === 0) return null;
  return (
    <ul className="mt-1.5 space-y-1">
      {remedies.map((err, i) => (
        <li key={`${err.entity}-${err.code}-${i}`}>
          <span className="font-medium">
            What Meta suggests{err.entity ? ` (${err.entity.toLowerCase().replace("_", " ")})` : ""}:
          </span>{" "}
          {err.solution}
          {err.code != null ? <span className="font-mono opacity-70"> #{err.code}</span> : null}
        </li>
      ))}
    </ul>
  );
}
